(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aphelion-referral"]) return;
  try {
    
document.addEventListener('click',async function(event){
  const button=event.target.closest('.aphelion-referral [data-coupon-copy]');
  if(!button)return;
  const box=button.closest('[data-coupon-box]');
  const status=box.querySelector('.aph-copy-status');
  const code=box.querySelector('.aph-coupon__code>strong');
  try{
    await navigator.clipboard.writeText(code.textContent.trim());
    status.textContent=button.dataset.copySuccess;
  }catch(error){
    const range=document.createRange();range.selectNodeContents(code);
    const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);
    status.textContent=button.dataset.copyFailure;
  }
});

  } catch(e) { console.error(e); }
})();
})();
